import React from 'react';
import { BarChart3, History } from 'lucide-react';
import { SalesHistoryTab } from './SalesHistoryTab';
import { FinancialAnalysisTab } from './FinancialAnalysisTab';

export const Analysis: React.FC = () => {
  const [tabValue, setTabValue] = React.useState(0);

  const tabs = [
    { label: 'Analiz', icon: BarChart3 },
    { label: 'Satış Geçmişi', icon: History },
  ];

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <div className="border-b border-border">
        <div className="flex gap-1">
          {tabs.map((tab, index) => {
            const Icon = tab.icon;
            const isActive = tabValue === index;
            return (
              <button
                key={tab.label}
                onClick={() => setTabValue(index)}
                className={`
                  flex items-center gap-2 px-4 py-3 text-sm font-medium
                  border-b-2 transition-smooth
                  ${
                    isActive
                      ? 'border-accent text-accent'
                      : 'border-transparent text-foreground-secondary hover:text-foreground hover:border-border'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {tabValue === 0 && <FinancialAnalysisTab />}
        {tabValue === 1 && <SalesHistoryTab />}
      </div>
    </div>
  );
};
